import type { ItemListMapValueType, OptionItemListMap, PathIndexMapType, SelectionMetadata } from '../type/common.type';
import { checkZigzinOrVendorFlexDeliveryType } from '../util/checkers/zigzin-checker';

/**
 * 옵션 선택 경로에 따른 아이템 찾기
 * @param item_list_map - 아이템 리스트 맵
 * @param complete_selection - 완료된 옵션 선택 상태
 * @returns 선택된 옵션에 해당하는 아이템 또는 null
 */
export const getItemListByOptionSelection = (item_list_map: OptionItemListMap, metadata: SelectionMetadata) => {
  const is_zigzin = checkZigzinOrVendorFlexDeliveryType(metadata.last_selected_shipping_type);
  const option_id_list = is_zigzin ? metadata.selected_zigzin_option_id_list : metadata.selected_general_option_id_list;
  return item_list_map['matched']?.get(option_id_list.join(';')) || null;
};

/**
 * 옵션 선택 경로에 따른 아이템 찾기
 * @param path_index_map - 경로별 아이템 인덱스 맵
 * @param optionPath - 선택된 옵션 경로
 * @returns 선택된 옵션에 해당하는 아이템 또는 null
 */
export const getPathIndexByOptionSelection = (path_index_map: PathIndexMapType, optionPath: string[]) => {
  return path_index_map.get(optionPath.join('/'));
};

/**
 * 이전 그룹 선택에서 BOGO 아이템 목록 추출
 * @param item_list_map - 옵션 아이템 목록 맵
 * @param previous_group_selections - 이전 그룹 선택 정보 목록
 * @returns BOGO 아이템 목록
 */
export const extractBogoItemList = (
  item_list_map: OptionItemListMap,
  previous_group_selections?: SelectionMetadata[],
): ItemListMapValueType[] => {
  if (!previous_group_selections || previous_group_selections.length === 0) {
    return [];
  }

  const bogo_items: ItemListMapValueType[] = [];

  for (const selection_metadata of previous_group_selections) {
    const item = getItemListByOptionSelection(item_list_map, selection_metadata);
    if (item) {
      bogo_items.push(item);
    }
  }

  return bogo_items;
};
